export default {
  'selectTradAcc': 'Select Trading Account',
  'tradeAccount': 'Trading Account',
  'accountInfo': 'Account Information',
  'latest_records': 'Latest Record',
  'download': 'Download',
  'deposit': 'Deposit',
  'withdrawal': 'Withdrawal',
  'transfer': 'Internal Transfer',
  'account_balance': 'Balance',
  'account_equity': 'Account Rights',
  'view_more': 'View More',
  'completed': 'Completed',
  'failure': 'Failed',
  'submitted': 'Submitted',
  'currency': 'Currency',
  'type': 'Type',
  'accountNo': 'Account Number',
  'toAccountNo': 'Transfer Out Account Number',
  'bankCardNo': 'Bank Card Number',
  'noDeposit': 'No Deposit Records',
  'noWithdrawal': 'No Withdrawal Records',
  'noFund': 'No Internal Transfer Records',
  'amount': 'Total',
  'order_No': 'Order Number',
  'stock': 'Securities',
  'futures': 'Futures',
  'forex': 'Foreign Exchange',
  'pm': 'Spot Gold',
  'platform': 'Platform',
  'total_cash': 'Net Cash Balance',
  'ref_portfolio': 'Reference Total Portfolio Value',
  'stockOptionsCash': 'Hong Kong Stock Option Account (Cash)',
  'securitiesCash': 'Hong Kong and Global Securities Accounts (Cash)',
  'securitiesMargin': 'Hong Kong and Global Securities Accounts (Margin)',
  'securitiesDayTradeMargin': 'Hong Kong Securities Day Trade Account (Margin)',
  'futuresMargin': 'Hong Kong and Global Futures Account (Margin)',
  'futuresDayTradeMargin': 'Hong Kong Futures Day Trade Account (Margin)',
  'interactiveBrokerIntegratedMargin': 'Interactive Brokers Integrated Account (Margin)',
  'STOCK': 'Securities',
  'FUTURES': 'Futures',
  'FOREX': 'Foreign Exchange',
  'mt5': '(MT5)',
  'mf': '(Eddid FX Pro)',
  'userStatus_title_one': 'Fill in Account Opening Information',
  'userStatus_title_two': 'Complete Account Opening Information',
  'userStatus_title_three': 'Account opening information is under review',
  'userStatus_description_one': 'You have not filled in the account opening information <br> Please scan the QR code to download the APP to complete the account opening',
  'userStatus_description_two': 'Your account opening information has not been completed <br> Please scan the QR code to download the APP and continue to filling in',
  'userStatus_description_three': 'Your application for account opening is under review  <br> Please scan the QR code to check the progress of account opening',
  'yesterdayBalance': 'Previous Balance',
  'accountBalance': 'Account Balance',
  'accountInterests': 'Net Value of Account',
  'dataFail': 'Data Error',
  'loadingData': 'Loading Data...',
  'balance': 'Today Balance',
  'enabled': 'Account Status',
  'enabled_false': 'Suspended',
  'enabled_true': 'Activated',
  'enabled_close': 'Closed',
  'ib': 'EddidPro',
  'dialogTexts': {
    'checkedText': 'I have read, acknowledged and understand the above terms',
    'privacy': 'Customer Disclaimer',
    'returnLogin': 'Return to Login',
    'confirm': 'Confirm',
    'tips': 'Please read and agree to the terms of the agreement',
    'confirmandread': 'I have read and agree'
  },
  'cdd': {
    'title': 'Customer Due Diligence Review',
    'context1': "Under the SFC's Anti-Money Laundering and Terrorist Financing Guidelines, licensed corporations are required to conduct regular 'Customer Due Diligence Reviews' for their clients.",
    'context2': 'Your trading account has not been active for some time and your trading account will be or has been frozen. If you still want to maintain your trading account, please confirm your updated personal information immediately. Is your personal information the same as the information submitted in your account application?',
    'context3': 'Is your personal data the same as the data submitted at the time of account opening?',
    'fileDiffContext': 'If your personal information has been updated, please contact customer service as soon as possible and submit the request form for data changes.'
  }
}
